module.exports = __webpack_public_path__ + "img/aps-hx-line.f59b0c9c.svg";